import { useEffect, useState } from 'react'
import { university2035IntegrationApi } from '@/api'
import { jsonConvert } from '@/helpers/jsonConvert'

const isEnabledValue = (value: unknown) =>
  value === true || value === 1 || value === '1'

export const useIsUniversity2035DigitalTraceEnabled = () => {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    let active = true

    university2035IntegrationApi
      .getConfig()
      .then((res: any) => {
        if (!active) return

        const fields = jsonConvert(res.data?.fields)
        setEnabled(
          !!fields &&
            typeof fields === 'object' &&
            isEnabledValue((fields as Record<string, unknown>).digital_trace_enabled),
        )
      })
      .catch(() => {
        if (active) setEnabled(false)
      })

    return () => {
      active = false
    }
  }, [])

  return enabled
}
